/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';

export const DivInlineTooltipContainerStyled = styled.div`
  ${({ theme, leftPos }) => {
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
    let top = -2;
    if (mediumUp) {
      top = 0;
    }

    return css`
    && {
      position: absolute;
      top: ${rem(top)};
      left: ${`${leftPos}px`};
    }`;
  }
}`;

